/**
 *
 * Navigator
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import IconButton from 'components/interaction/IconButton/index.jsx';
import cx from 'utils/cx.js';

const Title = styled.h3`
  min-width: 8em;
  text-align: center;
  transform: translateY(-0.15em);
`;

function Navigator(props) {
  const { onNavigate, label, className, navProps = {} } = props;

  function handleNavigate(action) {
    return () => onNavigate(action);
  }

  const iconProps = {
    variant: 'light',
    size: 'sm',
    className: 'py-2 text-gray',
    ...navProps,
  };
  return (
    <div className={cx('d-flex align-items-baseline', className)}>
      <IconButton {...iconProps} icon="ss-navigateleft fs-3" data-testid="navigator-previous" onClick={handleNavigate(navigate.PREVIOUS)} />
      <Title className="mx-4">{label}</Title>
      <IconButton {...iconProps} icon="ss-navigateright fs-3" data-testid="navigator-next" onClick={handleNavigate(navigate.NEXT)} />
    </div>
  );
}

Navigator.propTypes = {
  label: PropTypes.node,
  onNavigate: PropTypes.func,
  className: PropTypes.string,
  navProps: PropTypes.object,
};

export default Navigator;
